<div class="content" *ngIf="!isLoading">
	<ng-container *ngIf="data.settingType === 0">
		<div class="layout-auto-1">
			<div>
				<div class="app-space-top_1" >
					<h6>{{getRessource('Header.maxCapacity')}}</h6>
					<exg-input caption="Kapazität" type="number"
					           [ngModel]="capacityDefinition.DataSource.usr"
					           (ngModelChange)="capacityChange('usr', $event)">
					</exg-input>
					<exg-input *ngIf="userType === 1"
					           caption="Kapazität EIS" type="number"
					           [ngModel]="capacityDefinition.DataSource.adm"
					           (ngModelChange)="capacityChange('adm', $event)">
					</exg-input>
				</div>
				<div class="app-space-top_1" >
					<h6>{{getRessource('Header.capacity')}}</h6>
					<exg-input caption="Kapazität" type="number"
					           [ngModel]="capacityDefinition.DataSource.usrweek"
					           (ngModelChange)="capacityChange('usrweek', $event)">
					</exg-input>
					<exg-input *ngIf="userType === 1"
					           caption="Kapazität EIS" type="number"
					           [ngModel]="capacityDefinition.DataSource.admweek"
					           (ngModelChange)="capacityChange('admweek', $event)">
					</exg-input>
				</div>
			</div>
			<div class="content layout-auto-1">
				<div class="grid-1-auto">
					<h6>{{getRessource('Header.route')}}</h6>
					<div>
						<button (click)="createRegioRouteItem()" class="md-btn">
							{{getRessource('createRoute')}}
						</button>
					</div>
				</div>
				<div class="content app-space-left">
					<exg-data-list [rowSource]="routeDefinition.DataSource"
					               (RowDblClick)="editRouteItem($event)"
					               [displayState]="routeDefinition.DataSource.length == 0 ? 2 : 0">
						<ng-template #rowTemplate let-route>
							<div class="list-row list-row-1-auto "
							     [class.app-cursor-pointer]="canEditRouteEdit(0, route)"
							     [class.app-cursor-default]="!canEditRouteEdit(0, route)">
								<div class="list-two-line">
									<div class="list-primary-text">
										{{getRessource('Geplant')}} {{route.from | excDate:'Globals.DateFormat'}} - {{route.to | excDate:'Globals.DateFormat'}}
									</div>
									<div class="list-secondary-text">
										{{getRessource('Region')}}:
										<ng-container *ngFor="let location of route.locations; index as ix">
											{{location.postCode}}{{route.locations.length - 1 !== ix ? ', ' : ''}}
										</ng-container>
									</div>
								</div>
								<div>
									<i class="search-action far fa-trash-alt"
									   (click)="deleteRouteItem(route)"
									   [class.disabled]="!canEditRouteEdit(0, route)"
									></i>
								</div>
							</div>
						</ng-template>
					</exg-data-list>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="data.settingType === 1">
		<div class="layout-auto-1">
			<div class="grid-1-auto">
				<h6>{{getRessource('Header.absence')}}</h6>
				<div>
					<button (click)="createAbsenceItem()" class="md-btn">
						{{getRessource('createAbsence')}}
					</button>
				</div>
			</div>
			<div class="content app-space-left">
				<exg-data-list [rowSource]="absenceDefinition.DataSource"
				               (RowDblClick)="editAbsenceItem($event)"
				               [displayState]="absenceDefinition.DataSource.length == 0 ? 2 : 0">
					<ng-template #rowTemplate let-abs>
						<div class="list-row-1-auto app-cursor"
						     [class.app-cursor-pointer]="canEditAbsence(0, abs)"
						     [class.app-cursor-default]="!canEditAbsence(0, abs)">
							<div>
								<div class="spawn">
									<div class="list-primary-text">
										{{abs.from | excDate:'Globals.DateFormat'}} - {{abs.to | excDate:'Globals.DateFormat'}}
									</div>
									<div class="list-secondary-text app-space-left"
									     *ngIf="abs.noDispoFrom && abs.noDispoTo">
										({{abs.noDispoFrom | excDate:'Globals.DateFormat'}} - {{abs.noDispoTo | excDate:'Globals.DateFormat'}})
									</div>
								</div>
								<div class="list-secondary-text">{{getRessource('deputy')}}: {{abs.deputy}}</div>
							</div>
							<div>
								<i class="search-action far fa-trash-alt"
								   (click)="deleteAbsenceItem(abs)"
								   [class.disabled]="!canEditAbsence(0, abs)">
								</i>
							</div>
						</div>
					</ng-template>
				</exg-data-list>
			</div>
		</div>
	</ng-container>
  <ng-container *ngIf="userType === 1 && data.settingType === 2">
	  <div class="layout-auto-1">
		  <h6>{{getRessource('Header.blackwhitelist')}}</h6>
			<div class="content">
				<ng-container *ngFor="let def of listDefinition">
					<exg-panel class=""
					           [caption]="def.Entity + ' - ' + enumSvc.getFieldCaption(def.Entity,def.FieldName) + ' - '
	                 + def.ListType + ' - ' + def.Selected.length + ' / ' + def.DataSource.length + ' ausgewählt'">
						<ng-template #content>
							<div class="content">
								<div class="app-layout-blackwhitelist">
                  <div>
                  <small class="bwl-label bwl-label--white">{{getRessource('bwlWhite')}}</small>
                    <div
                      cdkDropList
                      #selected="cdkDropList"
                      style="margin: 0 1rem 0 1rem"
                      class="example-list"
                      [cdkDropListData]="def.ListType === 'WHITELIST' ? def.Selected : def.UnSelected"
                      [cdkDropListConnectedTo]="[unselected]"
                      (cdkDropListDropped)="drop($event)"
                      cdkDropListSortingDisabled>
                      <div cdkDrag class="example-box"
                           *ngFor="let row of (def.ListType === 'WHITELIST' ? def.Selected : def.UnSelected); let i = index">
                        {{row.caption}}
                      </div>
                    </div>
									</div>
									<div>
                    <small class="bwl-label bwl-label--black">{{getRessource('bwlBlack')}}</small>
                    <div
                      cdkDropList
                      #unselected="cdkDropList"
                      style="margin: 0 1rem 0 1rem"
                      class="example-list"
                      [cdkDropListData]="def.ListType === 'WHITELIST' ? def.UnSelected : def.Selected"
                      [cdkDropListConnectedTo]="[selected]"
                      (cdkDropListDropped)="drop($event)"
                      cdkDropListSortingDisabled>
                      <div cdkDrag class="example-box"
                           *ngFor="let row of (def.ListType === 'WHITELIST' ? def.UnSelected : def.Selected); let i = index">
                        {{row.caption}}
                      </div>
                    </div>
									</div>
								</div>
							</div>
						</ng-template>
					</exg-panel>
				</ng-container>
<!-- 				<exg-data-list class="typo-small" style="margin-left: 0.25rem" [rowSource]="listDefinition"> -->
<!-- 					<ng-template #rowTemplate let-def> -->
<!-- 						 -->
<!-- 					</ng-template> -->
<!-- 				</exg-data-list> -->
			</div>
      <div style="width:fit-content">
        <exg-checkbox class="md-check-reverse"
                      [caption]="getRessource('isBackupSV')"
                      [(ngModel)]="backupDefinition.isBackup"
                      (ngModelChange)="save()">
        </exg-checkbox>
      </div>
	  </div>
  </ng-container>
</div>
<ng-container *ngIf="isLoading">
  <div class="content">
    <div class="splash loading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-container>
